module.exports = __webpack_public_path__ + "media/images/icons/clock-80e2346b9602783b254fdf203a51dde0.svg";